import React from "react";
import { Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { ExtendedPermission } from "fond/types";
import { isNew } from "fond/utils/permissions";
import { ExternalChip, MemberChip } from "fond/widgets/AccountSwitch";

const TypeCellRenderer: React.FC<ICellRendererParams<ExtendedPermission, boolean>> = ({ value: isExternal, data: permission }) => {
  if (isExternal && permission) {
    const externalChip = <ExternalChip data-testid="external-chip" label="External" size="small" />;
    if (!isNew(permission)) {
      return (
        <Tooltip title="This user is not part of this account and cannot be granted permissions higher than collaborator">{externalChip}</Tooltip>
      );
    }
    return externalChip;
  }

  return <MemberChip data-testid="member-chip" label="Member" size="small" />;
};

export default TypeCellRenderer;
